<template>
  <b-modal
    id="modal-approval"
    cancel-variant="outline-secondary"
    centered
    size="sm"
    title="報銷審批"
    :ok-disabled="false"
    no-close-on-backdrop
    hide-footer
    headerClass="pr-3 py-2 border-bottom bgWhite"
    footerClass="px-3 py-2 border-top bgWhite"
  >
    <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
      <b-overlay
        :show="loading"
        spinner-variant="primary"
        spinner-type="grow"
        spinner-small
        rounded="sm"
      >
        <b-form class="" @submit.prevent="handleSubmit(onSubmit)" key="2">
          <div class="position-relative">
            <b-row>
              <!--  -->
              <b-col cols="12">
                <b-form-group
                  label="報銷編號："
                  label-for="claim_number"
                  label-cols-md="3"
                  class="align-items-center"
                >
                  <div class="">
                    {{ newApproveData.claim_number }}
                  </div>
                </b-form-group>
              </b-col>
              <!-- <b-col cols="12">
                <validation-provider
                  #default="validationContext"
                  name="報銷狀態"
                  rules="required"
                >
                  <b-form-group
                    label="報銷狀態："
                    label-for="claim_status_id"
                    label-cols-md="3"
                    class="required"
                  >
                    <v-select
                      id="claim_status_id"
                      v-model="newApproveData.claim_status_id"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="claimStatusOptions"
                      :clearable="false"
                      label="name"
                      :reduce="(option) => option.id"
                      placeholder="報銷狀態"
                    >
                    </v-select>
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col> -->
              <b-col cols="12">
                <b-form-group
                  label="批核備註："
                  label-for="approve_remark"
                  label-cols-md="3"
                >
                  <b-form-textarea
                    id="approve_remark"
                    v-model="newApproveData.approve_remark"
                    rows="3"
                    placeholder="輸入批核備註"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group
                  label="是否批准："
                  label-for="is_approved"
                  label-cols-md="3"
                >
                  <b-form-checkbox
                    id="is_approved"
                    v-model="newApproveData.is_approved"
                    name="is_approved"
                    switch
                    inline
                    :value="1"
                    :unchecked-value="0"
                  >
                    {{ newApproveData.is_approved === 1 ? "已批准" : "未批准" }}
                  </b-form-checkbox>
                </b-form-group>
              </b-col>
            </b-row>
            <div
              class="d-flex mt-1 flex-wrap flex-lg-nowrap justify-content-end"
            >
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="mr-sm-2 mobile-w100"
                type="submit"
              >
                <feather-icon size="16" class="mr-1" icon="CheckCircleIcon" />
                提交
              </b-button>
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="button"
                variant="outline-secondary"
                @click="hide"
                class="mt-1 mt-sm-0 mobile-w100"
              >
                取消
              </b-button>
            </div>
          </div>
        </b-form>
      </b-overlay>
    </validation-observer>
  </b-modal>
</template>

<script>
import vSelect from "vue-select";
import store from "@/store";
import Ripple from "vue-ripple-directive";
import "animate.css";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import zh_CN from "vee-validate/dist/locale/zh_CN.json";
localize("zh_cn", zh_CN);
import formValidation from "@core/comp-functions/forms/form-validation";
import { required, email } from "@validations";
import { ref, watch } from "@vue/composition-api";

import {
  BModal,
  BForm,
  BFormGroup,
  BFormInput,
  BFormFile,
  BFormInvalidFeedback,
  BFormCheckbox,
  BFormRadioGroup,
  BFormRadio,
  BFormTextarea,
  BInputGroup,
  BRow,
  BCol,
  BButton,
  BOverlay,
} from "bootstrap-vue";

export default {
  components: {
    BModal,
    BForm,
    BFormGroup,
    BFormInput,
    BFormFile,
    BFormInvalidFeedback,
    BFormCheckbox,
    BFormRadioGroup,
    BFormRadio,
    BFormTextarea,
    BInputGroup,
    BRow,
    BCol,
    BButton,
    BOverlay,
    vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      loading: false,
    };
  },
  props: {
    approveData: {},
    claimStatusOptions: {},
  },
  methods: {
    hide() {
      this.$root.$emit("bv::hide::modal", "modal-approval", "#btnShow");
    },
    onSubmit() {
      this.$swal({
        title: "你確定嗎?",
        text: "你確定提交資料嗎？",
        showCancelButton: true,
        confirmButtonText: "提交",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.loading = true;
          store
            .dispatch("claims/approve", this.newApproveData)
            .then((response) => {
              this.loading = false;
              this.$swal({
                text: response.data.message,
                icon: "success",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.$emit("refetch-data");
              this.hide();
            })
            .catch((error) => {
              this.loading = false;
              this.$swal({
                text: error.response.data.message,
                icon: "error",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
  },
  setup(props) {
    const loading = ref(false);
    const newApproveData = ref({
      id: 0,
    });
    watch(
      () => props.approveData,
      (newVal) => {
        newApproveData.value = { ...newVal };
      }
    );

    const resetApproveData = () => {
      newApproveData.value = JSON.parse(
        JSON.stringify({
          id: 0,
        })
      );
    };
    const { refFormObserver, getValidationState, resetForm } =
      formValidation(resetApproveData);

    return {
      loading,
      refFormObserver,
      getValidationState,
      resetForm,
      newApproveData,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
.modal-title {
  font-weight: bold;
}
</style>
